import { Button, Stack, Typography } from "@mui/material";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { ChangePasswordDialog } from "Components/UserAccount/Shared/UserSettings/ChangePasswordDialog";
import { IdentityProvider } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";

const RESOURCES = Resources.Components.UserAccount.ChangePassword;

export const PasswordSection = () => {
  const [isChangeOpen, setIsChangeOpen] = useState(false);
  const { data: userInfo } = useUserInfoQuery();
  const { t } = useResource();

  // Password management is only available to users who already have an
  // application password. Social-only accounts (Google/Apple) sign in via
  // their provider and have no password to change.
  if (!userInfo?.userIdentityProviders.includes(IdentityProvider.Application)) {
    return null;
  }

  return (
    <Stack gap={1}>
      <Typography variant="h6">{t(RESOURCES.SectionTitle)}</Typography>
      <Stack direction="row" mt={2}>
        <Button
          color="info"
          variant="outlined"
          onClick={() => setIsChangeOpen(true)}
        >
          {t(RESOURCES.OpenAction)}
        </Button>
      </Stack>
      <ChangePasswordDialog
        isOpen={isChangeOpen}
        onClose={() => setIsChangeOpen(false)}
      />
    </Stack>
  );
};
